// Login page Animation
export const isLoginPageAnimationEnabled = true;

// Login Page Style
export const isDefaultStyle = false; // true or false

//Logo -- Place your image in folder `src/assets/images`
export const logoPath = "Lavender_Logo_RGB.png";

//Pendo Analytics
export const pendoKey = process.env.VUE_APP_PENDO_API_KEY;
export const sponsorName = "AstraZeneca";
export const studyURL = "LAVENDER.Longboat.com";
export const studyId = "AZ464";
export const AppType = "CN";
export const pendoAccountName = studyId + '_' + AppType;

// Authentication
export const cookieExpiryTimeInMins = 5;
export const passwords = [{
        key: "pass", // key used for storing this password in cookie
        value: String(process.env.VUE_APP_PASSWORD), // password
        toRoute: "/", // go to this route/url after successful authentication
    },
];

// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = [
    "af",
    "bd",
    "bf",
    "bg",
    "bp",
    "cc",
    "ct",
    "da",
    "de",
    "el",
    "en",
    "es",
    "fc",
    "fr",
    "hg",
    "il",
    "it",
    "ja",
    "ko",
    "lp",
    "lt",
    "nl",
    "ns",
    "pl",
    "pt",
    "ro",
    "sk",
    "sp",
    "sr",
    "st",
    "sv",
    "th",
    "tl",
    "tn",
    "tr",
    "zl",
    "xh",
    "zh",
    "zu"
];